import { render } from "./PreviousLectureTeacher.vue?vue&type=template&id=42cc95fe&scoped=true"
import script from "./PreviousLectureTeacher.vue?vue&type=script&lang=js"
export * from "./PreviousLectureTeacher.vue?vue&type=script&lang=js"

import "./PreviousLectureTeacher.vue?vue&type=style&index=0&id=42cc95fe&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_UI\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cc95fe"]])

export default __exports__